import React from 'react';
import BaseForm from '../../../../../components/form/BaseForm';
import Panel from '../../../../../components/outline/Panel';
import Anchor from '../../../../../components/link/Anchor';
import { POINT_ISSUE_HISTORY_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { openNewWindow, setDetailPageUrl } from '../../../../../lib/common';
import { ReviewFindOneResponseBodyReviewDto } from '../../common/types/ReviewDetailTypes';
import './PointRetrieveDetailWrap.scss';

interface IPointRetrieveDetailWrapProps {
  reviewDetailInfo: ReviewFindOneResponseBodyReviewDto;
}

const PointRetrieveDetailWrap = (props: IPointRetrieveDetailWrapProps): JSX.Element => {
  const {
    reviewDetailInfo: {
      pointReturned: { adminId, memo, pointIssueHistoryId },
    },
  } = props;

  return (
    <Panel className="cs-review-detail-info">
      <div className="panel-header">
        <div className="title">포인트 정보</div>
      </div>
      <div className="panel-body">
        <div className="review-info-wrap">
          <div className="review-info">
            {/* 포인트 회수한 관리자 ID */}
            <BaseForm label="포인트 회수한 관리자 ID" content={adminId} />
            {/* 포인트 발급 내역 상세 ID */}
            <BaseForm
              label="포인트 발급 내역 상세 ID"
              content={
                <Anchor
                  color="primary"
                  isUnderLine
                  text={pointIssueHistoryId}
                  onClick={() =>
                    openNewWindow(setDetailPageUrl(POINT_ISSUE_HISTORY_DETAIL_URL_PATH, pointIssueHistoryId))
                  }
                />
              }
            />
            {/* 포인트 회수 사유 */}
            <BaseForm label="포인트 회수 사유" content={memo} />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default PointRetrieveDetailWrap;
